/* eslint-disable @next/next/no-img-element */
import { FC } from 'react'
import { RelatedArticle } from '@libs/types/generated/housing-market-ui'

interface ArticleCardsProps {
  articles: RelatedArticle[]
}

/*
Local link #1 - BAM
Local link #2 - Buying a House
Local link #3 - Selling a House
Local link #4 - Cost of Living
‘Else’ local links - Best Places, Closing Costs, Companies the Buy Houses
*/

const SHOW_ARTICLE_IMAGE = false

const formatPostModifiedDate = (date: string) =>
  new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  })

const ArticleCards: FC<ArticleCardsProps> = ({ articles }) => (
  <div>
    <h2 className="type-heading-two pb-2 mb-6">Related housing resources</h2>

    <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-x-8">
      {articles.map(post => (
        <article
          key={post.title}
          className="article Card Card--accentedBottom mb-8"
        >
          {SHOW_ARTICLE_IMAGE && (
            <div className="Card-imageContainer">
              <div className="image-container">
                <div className="image-wrapper">
                  <img
                    src={
                      'https://qa.bankrate.com/2023/03/23160414/Banking-3-25-news-roundup.jpg?auto=webp&fit=crop&width=344&height=250'
                    }
                    alt={post.title}
                    className="Card-image"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          )}
          <div className="Card-body">
            <span className="Card-subheader type-heading-five uppercase mb-6 text-gray-700">
              {post.topic?.replace(/-/g, ' ') || 'Real Estate'}
            </span>
            <p className="type-heading-four mb-8">
              <a className="Card-link" href={post.target_url}>
                {post.title}
              </a>
            </p>
            <p className="font-normal text-base mb-8 text-gray-700">
              {post.excerpt}
            </p>
            <div className="Card-additional">
              <span className="type-heading-six text-gray-900 uppercase">
                {post.minutes_to_read} min read
              </span>
              <span className="hidden sm:inline-block text-sm text-gray-700 self-end">
                {formatPostModifiedDate(post.modified)}
              </span>
            </div>
          </div>
        </article>
      ))}
    </div>
  </div>
)

export default ArticleCards
